// StepShell component for multi-step forms/wizards
// Full-screen two-column layout: left = brand panel, right = step content
// Props: { title, subtitle, children, footerLeft, footerRight, progressDots }

import React from 'react';
import ProgressDots from './ProgressDots.jsx';

const StepShell = ({
  title,
  subtitle,
  children,
  footerLeft,
  footerRight,
  progressDots
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 min-h-screen">
      {/* Left Panel - Brand */}
      <aside className="relative hidden md:flex min-h-screen items-center justify-center bg-cyan-100/70">
        <div className="text-center">
          {/* InfluenceHub Logo */}
          <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            InfluenceHub
          </h1>
          
          {/* Logo Icon */}
          <div className="w-24 h-24 mx-auto bg-gradient-to-r from-teal-500 to-purple-600 rounded-xl flex items-center justify-center shadow-lg">
            <span className="text-3xl font-bold text-white">IH</span>
          </div>
        </div>
      </aside>

      {/* Right Panel - Content */}
      <section className="min-h-screen overflow-y-auto bg-white">
        <div className="max-w-xl w-full mx-auto px-6 md:px-10 py-10 md:py-14">
          {/* Progress Dots */}
          {progressDots && (
            <div className="mb-6 md:mb-8">
              <ProgressDots 
                current={progressDots.current} 
                total={progressDots.total}
                className="justify-center"
              />
            </div>
          )}

          {/* Title and Subtitle */}
          <div className="mb-8 text-center">
            <h2 className="text-2xl font-extrabold text-gray-900">{title}</h2>
            <p className="mt-2 text-sm text-gray-600">{subtitle}</p>
          </div>

          {/* Step Content */}
          <div className="space-y-6">
            {children}
          </div>

          {/* Desktop Footer - Non-sticky */}
          <div className="hidden md:flex items-center justify-between gap-3 mt-6">
            {footerLeft}
            {footerRight}
          </div>
        </div>

        {/* Mobile Sticky Footer */}
        <div className="md:hidden sticky bottom-0 bg-white/80 backdrop-blur border-t">
          <div className="flex items-center justify-between gap-3 px-4 py-3">
            {footerLeft}
            {footerRight}
          </div>
        </div>
      </section>
    </div>
  );
};

export default StepShell;
